import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {ImSchemaFileDto} from "../../../model/dto/entity/im-schema-file.dto";


@Component({
    selector: 'im-schema-object-base-component',
    templateUrl: 'im-schema-object.component.html',
    standalone: false
})
export class ImSchemaObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    dto: ImSchemaFileDto;

    /**
     * On Object Change.
     */
    onObjectChanged() {

        this.handleName(this.dto.name);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
